import React from 'react'
import { TalkingPoint } from './TalkingPointsEditor'
import { TalkingPoint as TalkingPointEditor } from './TalkingPoint'

interface TalkingPointsProps {
    talkingPoints: TalkingPoint[],
    onChange: (updatedTalkingPoints: TalkingPoint[]) => void,
    disabled?: boolean
}

const TalkingPoints: React.FC<TalkingPointsProps> = ({ talkingPoints, onChange, disabled = false }) => {
    return (
        <div className="d-flex flex-column gap-3">
            {
                talkingPoints.map((talkingPoint, i) => (<TalkingPointEditor
                    disabled={disabled} talkingPoint={talkingPoint} key={i}
                    onChange={(updatedTP) => {
                        let updatedTPs = [...talkingPoints];
                        updatedTPs[i] = updatedTP;
                        onChange(updatedTPs);
                    }}
                    onDelete={() => {
                        let updatedTPs = [...talkingPoints];
                        updatedTPs.splice(i, 1);
                        onChange(updatedTPs);
                    }}
                />))
            }
            {
                !disabled &&
                <button type="button" className="unset-all add-more-btn" onClick={() => {
                    let updatedTPs = [...talkingPoints, { title: '', pointers: [] }];
                    onChange(updatedTPs);
                }}>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M10.6243 7.50033C10.6243 7.15515 10.3445 6.87533 9.99935 6.87533C9.65417 6.87533 9.37435 7.15515 9.37435 7.50033L9.37435 9.37535H7.49935C7.15417 9.37535 6.87435 9.65517 6.87435 10.0003C6.87435 10.3455 7.15417 10.6253 7.49935 10.6253H9.37435V12.5003C9.37435 12.8455 9.65417 13.1253 9.99935 13.1253C10.3445 13.1253 10.6243 12.8455 10.6243 12.5003L10.6243 10.6253H12.4993C12.8445 10.6253 13.1243 10.3455 13.1243 10.0003C13.1243 9.65517 12.8445 9.37535 12.4993 9.37535H10.6243V7.50033Z" fill="#007AFF" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99935 1.04199C5.0518 1.04199 1.04102 5.05277 1.04102 10.0003C1.04102 14.9479 5.0518 18.9587 9.99935 18.9587C14.9469 18.9587 18.9577 14.9479 18.9577 10.0003C18.9577 5.05277 14.9469 1.04199 9.99935 1.04199ZM2.29102 10.0003C2.29102 5.74313 5.74215 2.29199 9.99935 2.29199C14.2565 2.29199 17.7077 5.74313 17.7077 10.0003C17.7077 14.2575 14.2565 17.7087 9.99935 17.7087C5.74215 17.7087 2.29102 14.2575 2.29102 10.0003Z" fill="#007AFF" />
                        </svg>
                    </span>
                    Add More
                </button>
            }
        </div>
    )
}

export default TalkingPoints